export const EMAIL = { key: "email", message: "Email must be unique" }
